import { AxiosInstance } from 'axios'

import { userApiDefaultApiFactory } from '@src/api/default-api-factories'
import {
  DefaultApiDeleteMerchantGeneralBlockAllowedOrganizationIdsRequest,
  DefaultApiDeleteMerchantGeneralBlockListRequest,
  DefaultApiGetMerchantGeneralBlockDetailRequest,
  DefaultApiPostAdditionMerchantGeneralBlockListRequest,
  DefaultApiUpdateMerchantGeneralBlockListRequest,
  DefaultApiUpdateMerchantGeneralBlockAllowedOrganizationIdsRequest,
} from '@src/api/generated/user-api'

export const getMerchantGeneralBlock = async (instance: AxiosInstance) => {
  return await userApiDefaultApiFactory(instance).getMerchantGeneralBlock()
}

export const deleteMerchantGeneralBlockList = async (
  instance: AxiosInstance,
  params: DefaultApiDeleteMerchantGeneralBlockListRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).deleteMerchantGeneralBlockList(params)
}

export const postAdditionMerchantGeneralBlockList = async (
  instance: AxiosInstance,
  params: DefaultApiPostAdditionMerchantGeneralBlockListRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).postAdditionMerchantGeneralBlockList(params)
}

export const updateMerchantGeneralBlockList = async (
  instance: AxiosInstance,
  params: DefaultApiUpdateMerchantGeneralBlockListRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).updateMerchantGeneralBlockList(params)
}

export const getMerchantGeneralBlockDetail = async (
  instance: AxiosInstance,
  params: DefaultApiGetMerchantGeneralBlockDetailRequest
) => {
  return await userApiDefaultApiFactory(instance).getMerchantGeneralBlockDetail(
    params
  )
}

export const deleteMerchantGeneralBlockAllowedOrganizationIds = async (
  instance: AxiosInstance,
  params: DefaultApiDeleteMerchantGeneralBlockAllowedOrganizationIdsRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).deleteMerchantGeneralBlockAllowedOrganizationIds(params)
}

export const updateMerchantGeneralBlockAllowedOrganizationIds = async (
  instance: AxiosInstance,
  params: DefaultApiUpdateMerchantGeneralBlockAllowedOrganizationIdsRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).updateMerchantGeneralBlockAllowedOrganizationIds(params)
}

// Do Not Remove this line ===@import api client===
